module.exports = __webpack_public_path__ + "img/image_5.ce7626dc.png";